import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    mixins: [mainRegistrationMixin],
    computed: {
        getInvoiceTotal() {
            return this.$store.getters['registration/getInvoiceTotal']
        },
        getCouponTotal() {
            return this.$store.getters['registration/getCouponTotal']
        },
        getAllInvoiceArticles() {
            return this.$store.getters['registration/getAllInvoiceArticles']
        },
        getAllInvoiceArticlesGroupedByArticle() {
            return this.$store.getters['registration/getAllInvoiceArticlesGroupedByArticle']
        },
        currency() {
            try {
                return this.eventData.currency
            }catch (e) {
                return null
            }
        },
        currencySymbol() {
            try {
                switch (this.eventData.currency) {
                    case "USD":
                        return "$"
                    case "EUR":
                        return "€"
                    case "SFR":
                    case "CHF":
                        return "Fr."
                    default:
                        return this.eventData.currency
                }
            }catch (e) {
                return null
            }
        }
    },
    methods: {
        convertToHumanNumber(value, minTwoDigits = false){
            if(!minTwoDigits){
                return value.toLocaleString()
            }else{
                return value.toLocaleString(undefined, {minimumFractionDigits: 2});
            }
        }
    }
}
